import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '@/firebase';

export type MailNotificationSettings = {
    shipmentNotificationsEnabled: boolean;
};

export const DEFAULT_MAIL_NOTIFICATION_SETTINGS: MailNotificationSettings = {
    shipmentNotificationsEnabled: true,
};

const settingsDocRef = () => doc(db, 'SystemSettings', 'mailNotifications');

export const getMailNotificationSettings = async (): Promise<MailNotificationSettings> => {
    const snapshot = await getDoc(settingsDocRef());
    const data = snapshot.exists() ? (snapshot.data() as Partial<MailNotificationSettings>) : {};
    return {
        ...DEFAULT_MAIL_NOTIFICATION_SETTINGS,
        ...data,
    };
};

export const saveMailNotificationSettings = async (settings: MailNotificationSettings) => {
    await setDoc(settingsDocRef(), settings, { merge: true });
};
